import { render, staticRenderFns } from "./SearchSVG.vue?vue&type=template&id=8c86deb4&scoped=true&"
import script from "./SearchSVG.vue?vue&type=script&lang=js&"
export * from "./SearchSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c86deb4",
  null
  
)

export default component.exports